import AxiosInstance, { AxiosInstanceType } from '../../core/api/axiosinstance'
import { promiseToResult } from '../../utils'
import { AuthType } from '../../shared/enum/Auth'

/**
 * Auth API
 */

// Register - Validate
export interface PostRegValidateReq {
  phone?: string
  email?: string
  code?: string
  lang?: string
  invitedUserId?: number
}
export interface PostRegValidateRes { candidateId: string }
const postRegStart = (data: PostRegValidateReq) => {
  data.email = data?.email?.toLowerCase()
  return promiseToResult(AxiosInstance().post<PostRegValidateRes>(
    '/application/register/start',
    data,
  ))
}

// Register - Send-Sms-Code
export interface PostRegSendCodeReq {
  email?: string
  phone?: string
  instance: AuthType
}
export type PostRegSendCodeRes = boolean
const postRegSendCode = (data: PostRegSendCodeReq) => {
  data.email = data?.email?.toLowerCase()
  return promiseToResult(AxiosInstance().post<PostRegSendCodeRes>(
    '/application/register/send-sms-code',
    data,
  ))
}

// Register
export interface PostRegReq {
  hash?: string
  phone?: string
  email?: string
  code?: string
  invitedUserId?: string
  password?: string
}
export interface PostRegRes { token: string }
const postReg = (data: PostRegReq) => {
  data.email = data?.email?.toLowerCase()
  return promiseToResult(AxiosInstance().post<PostRegRes>(
    '/application/register/finalize',
    data,
  ))
}

// Login
export interface PostLoginReq {
  phone?: string
  email?: string
  password?: string
  code?: string
}
export interface PostLoginRes { token: string }
const postLogin = (data: PostLoginReq) => {
  data.email = data?.email?.toLowerCase()
  return promiseToResult(AxiosInstance().post<PostLoginRes>(
    '/application/login',
    {
      ...data,
      email: data.email || undefined,
      phone: data.phone || undefined,
    },
  ))
}

export interface PostLoginTypeReq {
  phone?: string
  email?: string
}
export interface PostLoginTypeRes {
  password: boolean
  sms: boolean
  telegram: boolean
  whatsApp: boolean
  email: boolean
}
const postLoginType = (data: PostLoginTypeReq) => {
  data.email = data?.email?.toLowerCase()
  return promiseToResult(AxiosInstance().post<PostLoginTypeRes>(
    '/application/login/available-types',
    {
      ...data,
      email: data.email || undefined,
      phone: data.phone || undefined,
    },
  ))
}

// Login - Send-Code
export interface PostLoginSendCodeReq {
  phone?: string
  email?: string
  instance?: AuthType
}
export interface PostLoginSendCodeRes {
  sendCodeToInstance: number
  availableLoginType: {
    password: boolean
    sms: boolean
    telegram: boolean
    whatsApp: boolean
  }
}
const postLoginSendCode = (data: PostLoginSendCodeReq) => {
  data.email = data?.email?.toLowerCase()
  return promiseToResult(AxiosInstance().post<PostLoginSendCodeRes>(
    '/application/login/send-code',
    data,
  ))
}

// Recovery - Send-Code
export interface PostRecoverySendCodeReq { phone?: string, email?: string }
export interface PostRecoverySendCodeRes {
  instance: number
}
const postRecoverySendCode = (data: PostRecoverySendCodeReq) => {
  data.email = data.email?.toLowerCase()
  return promiseToResult(AxiosInstance().post<PostRecoverySendCodeRes>(
    '/application/login/forgot/send-code',
    {
      ...data,
      email: data.email || undefined,
      phone: data.phone || undefined,
    },
  ))
}

// Recovery
export interface PostRecoveryReq {
  phone?: string
  email?: string
  code: string
  password: string
  file?: File
}
export interface PostRecoveryRes {
  token: string
}
const postRecovery = (data: PostRecoveryReq) => {
  const body = new FormData()
  data.phone && body.append('phone', data.phone)
  data.email && body.append('email', data.email)
  body.append('code', data.code)
  body.append('password', data.password)
  if (data.file) {
    body.append('file', data.file)
  }

  return promiseToResult(AxiosInstance(AxiosInstanceType.FORMDATA).post<PostRecoveryRes>(
    '/application/login/forgot',
    body,
  ))
}

// Recovery - Validate
export interface PostRecoveryValidateReq {
  phone?: string
  email?: string
  code: string
}
export interface PostRecoveryValidateRes {
  status: boolean
}
const postRecoveryValidate = (data: PostRecoveryValidateReq) => {
  return promiseToResult(AxiosInstance().post<PostRecoveryValidateRes>(
    '/application/login/forgot/validate',
    {
      ...data,
      email: data.email || undefined,
      phone: data.phone || undefined,
    },
  ))
}

export type GetLoginRefreshRes = PostRecoveryRes
const getLoginRefresh = () => {
  return promiseToResult(AxiosInstance().get<GetLoginRefreshRes>(
    '/application/login/refresh',
  ))
}

const getLogout = () => {
  return promiseToResult(AxiosInstance().get(
    '/application/login/logout',
  ))
}

export const AuthAPI = {
  postRegStart,
  postRegSendCode,
  postReg,
  postLogin,
  postLoginType,
  postLoginSendCode,
  getLoginRefresh,
  getLogout,
  postRecoverySendCode,
  postRecovery,
  postRecoveryValidate,
}
